import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

const routeNames = {
  "/members": "Members",
  "/members/sermons": "Sermons",
  "/members/devotionals": "Devotionals",
  "/members/events": "Events",
  "/members/resources": "Resources",
  "/members/directory": "Directory",
  "/blog": "Blog",
  "/terms": "Terms & Policies",
  "/get-started": "Get Started",
  "/start-a-church-school": "Start a School",
  "/church-school-program": "Church School Program",
  "/our-schools": "Our Schools",
  "/prayer-request": "Prayer Request",
};

// Hide breadcrumbs for pages with dynamic IDs (blog posts, etc.)
const hideBreadcrumbPatterns = [/^\/blog\/.+/];

export default function Breadcrumbs() {
  const location = useLocation();
  const path = location.pathname;

  // Hide breadcrumbs for dynamic pages
  if (hideBreadcrumbPatterns.some(p => p.test(path))) return null;

  // Build breadcrumb trail
  const parts = path.split("/").filter(Boolean);
  const crumbs = [];

  let accumulated = "";
  for (const part of parts) {
    accumulated += `/${part}`;
    const name = routeNames[accumulated] || part.charAt(0).toUpperCase() + part.slice(1);
    crumbs.push({ path: accumulated, name });
  }

  if (crumbs.length <= 1) return null;

  return (
    <nav data-testid="breadcrumbs" className="bg-[#FAF9F6] border-b border-[#E5E2DC] px-6 md:px-12 py-3">
      <div className="max-w-7xl mx-auto flex items-center gap-2 text-sm">
        <Link to="/" className="text-[#595959] hover:text-[#C8A97E] transition-colors">
          <Home className="w-3.5 h-3.5" />
        </Link>
        {crumbs.map((crumb, i) => (
          <span key={crumb.path} className="flex items-center gap-2">
            <ChevronRight className="w-3.5 h-3.5 text-[#595959]/50" />
            {i === crumbs.length - 1 ? (
              <span className="text-[#1C2E4A] font-medium">{crumb.name}</span>
            ) : (
              <Link to={crumb.path} className="text-[#595959] hover:text-[#C8A97E] transition-colors">
                {crumb.name}
              </Link>
            )}
          </span>
        ))}
      </div>
    </nav>
  );
}
